const NodeLastPost = ({lastPostUrl, lastPostDate, lastThreadTitle}) => {
	return (
		<>
			<div className="min-w-0 flex flex-col overflow-hidden whitespace-nowrap">
				<a href={lastPostUrl} title={lastThreadTitle}
				   className="text-sm text-url font-semibold max-w-full text-ellipsis overflow-hidden">
					{lastThreadTitle}
				</a>
				<span className="text-xs text-url opacity-85 max-w-full text-ellipsis overflow-hidden">
					{lastPostDate}
				</span>
			</div>
		</>
	)
}

const NodeMessageCount = ({title, count, isMobile = false}) => {
	return (
		<>
			<span className="text-xs text-url opacity-85">{title}</span>
			<span className={`text-white font-semibold ${isMobile ? 'text-xs' : 'text-md'}`}>{count}</span>
		</>
	)
}

const Node = ({node}) => {

	if (node) {
		return (
			<div className="node border-b border-borderColor">
				<div className="flex items-center py-4 px-2">
					<div className="flex items-center justify-center flex-shrink-0 flex-grow-0">
						<span
							className={`block w-[37px] h-[37px] node-icon ${(node.type_data && node.type_data.is_unread) && 'is-unread'}`}>
						</span>
					</div>

					<div className="flex-1 min-w-0">
						<h3 className={`text-url text-xl ${(node.type_data && node.type_data.is_unread) ? 'font-bold' : 'font-light'} hover:underline`}>
							<a href={node.view_url} title={node.title}>{node.title}</a>
						</h3>

						<div className="md:hidden">
							<div className="flex text-xs text-url opacity-85 items-center">
								{(node.type_data && node.type_data.discussion_count) && (
									<span className="inline-flex gap-x-2 mr-2">
										<NodeMessageCount title={'Chủ đề'} count={node.type_data.discussion_count}/>
									</span>
								)}

								{(node.type_data && node.type_data.message_count) && (
									<span className="inline-flex gap-x-2">
										<NodeMessageCount title={'Bài viết'} count={node.type_data.message_count}/>
									</span>
								)}
							</div>

							<div className="flex items-center gap-x-2 mt-2">
								<NodeLastPost lastPostUrl={node.type_data.last_post_url}
								              lastPostDate={node.type_data.last_post_date}
								              lastThreadTitle={node.type_data.last_thread_title}
								/>
							</div>
						</div>
					</div>

					<div className="w-[70px] hidden flex-col justify-center items-center md:flex">
						{(node.type_data && node.type_data.discussion_count) && (
							<NodeMessageCount title={'Chủ đề'} count={node.type_data.discussion_count}/>)}
					</div>

					<div className="w-[70px] hidden flex-col justify-center items-center md:flex">
						{(node.type_data && node.type_data.message_count) && (
							<NodeMessageCount title={'Bài viết'} count={node.type_data.message_count}/>)}
					</div>

					{(node.type_data && node.type_data.LastPost) && (
						<div className="w-[140px] hidden items-center gap-x-1 overflow-hidden md:flex">
							<NodeLastPost lastPostUrl={node.type_data.last_post_url}
							              lastPostDate={node.type_data.last_post_date}
							              lastThreadTitle={node.type_data.last_thread_title}
							/>
						</div>
					)}
				</div>
			</div>
		)
			;
	}
}

export default Node;